import { formatElements } from '@/utils/hooks/format/formatCaptionText/utils/formatElements';

type OffsetReplaceProps = {
    text: string;
    components: React.ReactElement[] | Record<string, React.ReactElement>;
};

export function OffsetReplace({ text, components }: OffsetReplaceProps): React.ReactNode {
    if (!components || Object.keys(components)?.length === 0) return text;

    return formatElements(text, components);
}
